<template>
  <text-input
    v-bind="{ required, label: showLabel }"
    :value="email"
    @input="updateEmail"
    :error="$root.errorBag.email">
    {{ label }}
  </text-input>
</template>
<script>

export default {

  props: {
    store: {
      type: String,
      default: 'user'
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  
  methods: {
    updateEmail(value) {
      this.$store.commit(`${this.store}/updateEmail`, value)
    }
  },

  computed: {
    email() {
      return this.$store.getters[`${this.store}/user`].email
    },
    showLabel() {
      return (this.label.length > 0)
    }
  }

}
</script>